import * as React from "react";
import { useState, useEffect } from "react";
import DashboardTab from "./DashboardTab";
import WhatsAppConnectionFlow from "./WhatsAppMaterialUI";
import Container from "@mui/material/Container";
import {
  Box,
  Backdrop,
  CircularProgress,
  Typography,
  Paper,
} from "@mui/material";
import { useAuth } from "../../hooks/AuthProvider";
import { GET_WABA_CONNECTION_STATUS } from "../../config/urls";

const Dashboard = (props) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const { getValidToken } = useAuth();
  // conversations.view is granted only by WhatsApp addons, so it marks the WA channel
  const hasWa = JSON.parse(localStorage.getItem("permissions") || "[]").includes(
    "conversations.view"
  );
  const [whatsappConnectionStatus, setWhatsappConnectionStatus] =
    useState(null);
  const [loadingConnectionStatus, setLoadingConnectionStatus] = useState(hasWa);

  const checkWhatsAppConnectionStatus = async () => {
    try {
      setLoadingConnectionStatus(true);
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");

      const response = await fetch(GET_WABA_CONNECTION_STATUS, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-Id": tenant,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch WhatsApp connection status");
      }

      const data = await response.json();
      console.log("WhatsApp Connection Status Response:", data);

      const isConnected = data.status === "success";
      setWhatsappConnectionStatus(isConnected);
    } catch (error) {
      console.error("Error checking WhatsApp connection status:", error);
      setWhatsappConnectionStatus(false);
    } finally {
      setLoadingConnectionStatus(false);
    }
  };

  const handleWhatsAppConnectionComplete = () => {
    checkWhatsAppConnectionStatus();
    setRefreshKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    if (hasWa) checkWhatsAppConnectionStatus();
  }, []);

  if (loadingConnectionStatus) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <CircularProgress />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Checking WhatsApp connection...
        </Typography>
      </Box>
    );
  }

  // Show WhatsApp connection flow if not connected - but don't block the entire layout
  if (hasWa && !whatsappConnectionStatus) {
    return (
      <div className="App" >
        <Container maxWidth={false}>
          {/* Show a blocked dashboard state */}
          <Box sx={{ position: "relative" }}>
            {/* Semi-transparent dashboard */}
            <Box
              sx={{
                filter: "blur(8px)",
                pointerEvents: "none",
                opacity: 0.7,
                minHeight: "100vh",
              }}
            >
              <DashboardTab key={refreshKey} onNavigate={props.onNavigate} />
            </Box>

            {/* WhatsApp Connection Overlay */}
            <Backdrop
              open={true}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "100%", maxWidth: "500px", m: 2 }}>
                <WhatsAppConnectionFlow
                  onConnectionComplete={handleWhatsAppConnectionComplete}
                />
              </Box>
            </Backdrop>
          </Box>
        </Container>
      </div>
    );
  }

  // Normal dashboard rendering when WhatsApp is connected
  return (
    <div className="App">
      <Container disableGutters maxWidth={false}>
        <DashboardTab key={refreshKey} onNavigate={props.onNavigate} />
      </Container>
    </div>
  );
};

export default Dashboard;
